var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('zg-kh-account-modify',{attrs:{"account-center":"fundAccountHome"}}),_c('div',{staticClass:"fix-height"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }